import React from "react";
// mui 5
import Typography from "@mui/material/Typography";

function EmptyCart() {
  return (
    <Typography variant="subtitle1">
      You have no items in your cart. Start adding
    </Typography>
  );
}

export default EmptyCart;
